var exports = {
  "DR": "Box_0__dR0_nG",
  "xe": "space__sJ1vC3",
  "xA": "notReady__y6xZjA",
};

module.exports = exports;
